<template>
  <form class="search-bar" v-on:submit.prevent="doSearchParamMovieSearch">
    <div class="form-group date-range">
      <label class="form-control-label">期間</label>
      <div class="ws-nowrap">
        <MyCalendar
          class="date-from"
          :date-value="movieSearch.params.dtFrom"
          :set-date-value-once="false"
          @date-input="onDateParamChange('from', $event)"
        />
        <span class="ib waveline ta-center">〜</span>
        <MyCalendar
          class="date-to"
          :date-value="movieSearch.params.dtTo"
          :set-date-value-once="false"
          @date-input="onDateParamChange('to', $event)"
        />
      </div>
    </div>
    <div class="param-spacer"></div>
    <div class="form-group road-name">
      <label class="form-control-label">路線名</label>
      <select v-model="movieSearch.params.roadNameDispObj" class="custom-select" @change="onRoadNameDispChange()">
        <option :value="null"></option>
        <option v-for="(e, idx) in masters.kp.roadNameDisps" :key="idx" :value="e">
          {{e.roadNameDispShort}}
        </option>
      </select>
    </div>
    <div class="form-group direction">
      <label class="form-control-label">方向</label>
      <select
        v-model="movieSearch.params.direction"
        class="custom-select"
        :disabled="!movieSearch.params.roadNameDispObj"
      >
        <option :value="''"></option>
        <option v-for="(e, idx) in (movieSearch.params.roadNameDispObj || {}).directions" :key="idx">
          {{e}}
        </option>
      </select>
    </div>
    <div class="form-group kilopost-range">
      <label class="form-control-label">キロポスト</label>
      <div class="ws-nowrap">
        <input
          v-model="movieSearch.params.kpCalcFrom"
          type="text"
          :disabled="!movieSearch.params.direction"
          class="ib form-control kp-calc-from"
        />
        <span class="ib waveline ta-center">〜</span>
        <input
          v-model="movieSearch.params.kpCalcTo"
          type="text"
          :disabled="!movieSearch.params.direction"
          class="ib form-control kp-calc-to"
        />
      </div>
    </div>
    <div class="param-spacer"></div>
    <div class="form-group car-number">
      <label class="form-control-label">車両番号</label>
      <select v-model="movieSearch.params.carName" class="custom-select">
        <option :value="''"></option>
        <option v-for="e in devices" :key="e.deviceId" :value="e.carName">
          {{e.carName}}
        </option>
      </select>
    </div>
    <div class="param-spacer"></div>
    <div class="form-group tag-btn">
      <button class="btn btn-secondary" type="button" @click="openTagModal">
        <i class="fas fa-tag"></i>
      </button>
      <div class="ib ml4" v-if="(movieSearch.params.tags?.length ?? 0) > 0">
        <span class="tag-badge mr4" :class="'tag-badge-' + e.tagType1" v-for="e in movieSearch.params.tags" :key="e.id">
          {{e.tagName}}
        </span>
      </div>
    </div>
    <div class="form-group search-btn ta-center ws-nowrap">
      <div class="ib" v-tooltip.top="searchParamMovieSearchButtonTooltip">
        <button type="submit" class="btn btn-primary ib" :disabled="!isValidMovieSearchParams">
          動画検索
        </button>
      </div>
      <span class="badge badge-pill badge-success ml8 search-type-text" v-if="isMovieSearchResultModeArea">
        範囲検索中
      </span>
      <span class="badge badge-pill badge-warning ml8 search-type-text" v-if="isMovieSearchResultModeRoute">
        ルート検索中
      </span>
    </div>
  </form>
</template>

<script setup lang="ts">
import type { Device } from 'src/models/device';
import { useReactiveMasters } from 'src/composables/useMasters';
import { useMovieSearchStore } from 'src/composables/useMovieSearch';

defineProps<{
  devices: Device[];
}>();

const { masters } = useReactiveMasters();
const {
  movieSearch,
  isValidMovieSearchParams,
  isMovieSearchResultModeArea,
  isMovieSearchResultModeRoute,
  searchParamMovieSearchButtonTooltip,
  doSearchParamMovieSearch,
  onDateParamChange,
  onRoadNameDispChange,
  openTagModal,
} = useMovieSearchStore();
</script>

<style lang="scss" scoped>
.search-bar {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  .form-group {
    margin: 6px 12px;
    &.date-range {
      .date-from, .date-to { width: 96px; }
      .waveline { width: 20px; }
    }
    &.road-name {
      width: 160px;
      margin-right: 6px;
    }
    &.direction {
      width: 80px;
      margin-right: 6px;
    }
    &.kilopost-range {
      .kp-calc-from, .kp-calc-to { width: 64px; }
      .waveline { width: 20px; }
    }
    &.car-number {
      width: 150px;
    }
    &.tag-btn {
      align-self: flex-end;
    }
    &.search-btn {
      width: 120px;
      align-self: flex-end;
    }
    .form-control-label {
      margin: 0 0 2px 0;
    }
  }

  .param-spacer {
    align-self: flex-end;
    width: 1px;
    height: 38px;
    margin: 4px 2px;
    background-color: #ced4da;
  }
}

.search-type-text {
  padding: 6px 8px;
  font-weight: normal;
}
</style>
